import fetch from 'isomorphic-fetch';
import { checkStatus } from '../util';
import { ROOT, MAPSERVER_URL } from '../../constants/root';
import { Event } from "../../GAnalytics";
import { getMapServerParams } from '../../businessLogic/map';

export function getDocuments() {
	return function(dispatch, getState) {

		// Builds credentials
		const URL = `${ROOT}/document/position/`;

		// Set visual UI
		dispatch(isFetchingExplorer(true));

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setExplorerDocuments(json));
			dispatch(isFetchingExplorer(false));
		})
		.catch((e) => {
			dispatch(isFetchingExplorer(false));
			console.error(e);
		});
	};
}

export function getDocumentsInArea(rect) {
	Event('Explorer', 'getDocumentsInArea', 'Filtrou documentos por Área ' + JSON.stringify(rect));
	return function(dispatch, getState) {

		// Builds credentials
		const URL = `${ROOT}/document/point_position/`;

		// Set visual UI
		dispatch(isFetchingExplorer(true));

		return fetch(URL, {
			method: 'POST',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(rect)
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			const ids = [];
			json.map((d) => ids.push(d.id));
			dispatch(setIds(ids));
			dispatch(isFetchingExplorer(false));
		})
		.catch((e) => {
			dispatch(isFetchingExplorer(false));
			console.error(e);
		});
	};
}

export function getMapLayers() {
	return function(dispatch, getState) {

		// Builds credentials
		const URL = `${ROOT}/maplayer/`;
		// Set visual UI
		dispatch(isFetchingExplorerMapLayers(true));

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setMapLayers(json));
		})
		.finally(() => dispatch(isFetchingExplorerMapLayers(false)))
		.catch((e) => {
			// dispatch(isFetchingExplorer(false));
			console.error(e);
		});
	};
}

export function changeOneMapLayer(id, openOrCheck) {
	return function(dispatch, getState) {
		dispatch(setOneMapLayer(id, openOrCheck));
	};
}

function isFetchingExplorer(bool) {
	return {
		type: "IS_FETCHING_EXPLORER",
		bool
	};
}

function isFetchingExplorerMapLayers(bool) {
	return {
		type: "IS_FETCHING_EXPLORER_MAPLAYERS",
		bool
	};
}

export function setSectors(sectors) {
	Event('Explorer', 'setSectors', 'Definiu setores: ' + JSON.stringify(sectors));
	return {
		type: "SET_FILTER_SECTORS",
		sectors
	};
}

export function setLocalities(localities) {
	Event('Explorer', 'setLocalities', 'Definiu localidades: ' + JSON.stringify(localities));
	return {
		type: "SET_FILTER_LOCALITIES",
		localities
	};
}

export function setSamplingPoints(samplingPoints) {
	Event('Explorer', 'setSamplingPoints', 'Definiu pontos de amostragem: ' + JSON.stringify(samplingPoints));
	return {
		type: "SET_FILTER_SAMPLING_POINTS",
		samplingPoints
	};
}

export function setKeywords(keywords) {
	Event('Explorer', 'setKeywords', 'Definiu palavras-chave: ' + JSON.stringify(keywords));
	return {
		type: "SET_FILTER_KEYWORDS",
		keywords
	};
}

export function setIds(ids) {
	return {
		type: "SET_FILTER_IDS",
		ids
	};
}

function setExplorerDocuments(documents) {
	return {
		type: "SET_EXPLORER_DOCUMENTS",
		documents
	};
}

export function setExplorerSelectedDocuments(selected) {

	return {
		type: "SET_EXPLORER_SELECTED_DOCUMENTS",
		selected
	};
}

export function addLayer(layer) {
	Event('Explorer', 'AddLayer', 'Adicionou camada: ' + layer.name);
	return {
		type: "ADD_EXPLORER_LAYER",
		layer
	};
}

export function removeLayer(id) {
	Event('Explorer', 'RemoveLayer', 'Removeu camada');
	return {
		type: "REMOVE_EXPLORER_LAYER",
		id
	};
}

export function moveLayer(dragIndex, hoverIndex, layer) {
	// Event('Explorer', 'MoveLayer', 'Moveu camada: ' + layer.viewName);
	return {
		type: "MOVE_EXPLORER_LAYER",
		dragIndex,
		hoverIndex,
		layer
	};
}

export function resetLayers() {
	Event('Explorer', 'ResetLayer', 'Resetou as camadas');
	return {
		type: "RESET_EXPLORER_LAYERS"
	};
}

export function setShowLegend(bool) {
	Event('Explorer', 'ShowLegend', 'Exibir legendas: ' + bool);
	return {
		type: "SET_SHOW_LEGEND",
		bool
	};
}

export function setHideDocumentsFromMap(bool) {
	Event('Explorer', 'HideDocumentsFromMap', 'Ocultar Documentos: ' + bool);
	return {
		type: "SET_HIDE_DOCUMENTS_FROM_MAP",
		bool
	};
}

export function setMapLayers(mapLayers) {
	return {
		type: "SET_MAP_LAYERS",
		mapLayers
	};
}

export function setOneMapLayer(id, openOrCheck) {
	return {
		type: "SET_ONE_MAP_LAYER",
		id, openOrCheck
	};
}

export function getMapLayerCapabilities(layer, onSuccess) {
	const params = getMapServerParams(layer);

	const base = `${MAPSERVER_URL}MAP=`;
	const tail = '&srs=EPSG:4326&version=1.1.1&REQUEST=GetCapabilities&SERVICE=WMS';
	const URL = `${base}${params.file}${tail}`;

	return function(dispatch, getState) {
		return fetch(URL, { method: 'GET' })
		.then((response) => response.text())
		.then((xmltext) => {
			var convert = require('xml-js');

			const json = convert.xml2js(xmltext, {compact: true, spaces: 4});

			let parser = new DOMParser();
			const xmlDoc = parser.parseFromString(xmltext, "text/xml");

			onSuccess(json, xmlDoc);
		}).catch((e) => {
			console.error(e);
		});
	};
}


// WEBPACK FOOTER //
// ./src/state/explorer/actions.js